import React from "react"
import fuzzysort from "fuzzysort"

import { useNana } from "../hooks/useNana"
import { Idea } from "../../model/types"
import Autocomplete, {
  AutocompleteInputStyle,
  AutocompleteOptions,
  AutocompleteResult,
} from "./autocomplete"
import IdeaBox from "./idea_box"

const GoalAutocomplete = ({
  select,
  onEscape,
  placeholder,
  inputStyle,
  canSelectNone,
}: {
  select: (source: AutocompleteResult<Idea>, filter: string) => boolean
  onEscape: () => void
  placeholder?: string
  inputStyle: AutocompleteInputStyle
  canSelectNone?: boolean
}) => {
  const { model } = useNana()

  const options: AutocompleteOptions<Idea> = {
    select,
    canSelectNone,
    placeholder: placeholder || "Search for goal",
    emptyMessage: "No goals found.",
    fetchItems: (filter: string): Idea[] => {
      const allGoals = model
        .getGoals()
        .sort((a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0))
      if (filter === "") return allGoals
      return fuzzysort
        .go(filter, allGoals, {
          limit: 10,
          threshold: -1000,
          keys: ["title", "memo"],
        })
        .map((result) => result.obj)
    },
    renderItem: (result: AutocompleteResult<Idea>) => {
      if (result.type == "none") {
        return <div className="cursor-pointer h-6 flex ">No goal attached</div>
      } else {
        const goal = result.item
        return (
          <div className="cursor-pointer flex justify-start items-center gap-3">
            <IdeaBox idea={goal} />
            <div className="overflow-hidden text-ellipsis whitespace-nowrap">
              {goal.title}
            </div>
          </div>
        )
      }
    },
    onEscape,
    inputStyle: inputStyle,
  }
  return <Autocomplete {...options} />
}

export default GoalAutocomplete
